/*
      VERSION DU CARNET AVEC ENIMES AUX VASES
*/

const MUSEEROMA = [
    {
      page: 2,
      lib: "Première énigme !",
      texteIndice: ["Rien à ré-écrire pourtant", "S'imaginer déplacer, mais ne touchez à rien", "Retourner (lisez à l'envers)"]
    },
    {
      page: 4,
      lib: "A bien voir...",
      texteIndice: [
        "Chronologie fait sens",
        "Classez les plantes d'une introduction la plus ancienne à la plus récente",
        "L’Achillée"
      ]
    },
    {
      page: 6,
      lib: "Photo indice",
      texteIndice: [
        "Tout est question d'échelle",
        "Il vous suffit de comparer",
        "Comparez la taille des suspects à la photo",
        "Le suspect n'est PAS Pierre Arancif"
      ]
    },
    {
      page: 9,
      lib: "Saint-Luc",
      texteIndice: [
        "Retrouvez la stèle",
        "De la phrase du carnet retirez les mots tels que REGIS",
        "Dix"
      ]
    },
    {
      page: 11,
      lib: "Etiquettes",
      texteIndice: [
        "Il faut bien faire la somme des petites pastilles blanches rattachées à chaque oeuvre",
        "Mais l'une d'entre elle ne va pas",
        "Vingt six (le dernier 6 devient un 9)"
      ]
    },
    {
      page: 13,
      lib: "Lumières",
      texteIndice: [
        "Et non 110 n'est pas la réponse",
        "Les recyclés sont aussi recyclables",
        "Cent onze"]
    },
    {
      page: 16,
      lib: "Vision",
      texteIndice: [
        "Comparez",
        "Il y a des dents en trop",
        "Long"
      ]
    },
    {
      page: 18,
      lib: "Affaire de sens",
      texteIndice: [
        "Deux choses à compter",
        "Des AGILES, GLAISE.... AIGLES ?",
        "10 + 12 = vingt deux"
      ]
    },
    {
      page: 20,
      lib: "Le radeau",
      texteIndice: [
        "Trouvez la bonne mosaïque, le dessin aide",
        "Assemblez les lettres commes les motifs de la mosaïque",
        "Cancan"
      ]
    },
    {
      page: 22,
      lib: "Stèles",
      texteIndice: [
        "Retrouvez déjà les stèles",
        "Remettez les dans le bon ordre",
        "TRESORS"
      ]
    },
    {
      page: 24,
      lib: "La course",
      texteIndice: [
        "Trouvez la bonne vitrine",
        "Des lampes à huiles montrent la réponse",
        "Sanglier"
      ]
    },
    {
      page: 26,
      lib: "L'As des As",
      texteIndice: [
        "L'As exposé permet juste de voir quoi chercher",
        "Vous avez la réponse en main",
        "Une fois l'indice trouvé, retirez les lettres TOUT",
        "Le suspect n'est PAS Mme Giree"
      ]
    },
    {
      page: 29,
      lib: "Prise de hauteur",
      texteIndice: [
        "Un problème central",
        "Penchez-vous mais pas au bord",
        "Conservez les Asterix et ..",
        "Romanité"
      ]
    },
    {
      page: 31,
      lib: "Horizon",
      texteIndice: ["Comparez",
        "Il manque quelque chose, venant d'où ?", "Eglise Saint Paul"]
    },
    {
      page: 33,
      lib: "Alibis",
      texteIndice: [
        "Il y a bien un alibi qui contient une erreur factuelle",
        "Le palais de justice n'a que 3 étages, impossible d'être au 5ème",
        "Le wine bar est bien au RDC, l'alibi est crédible",
        "Seul le suspect n°4 est correct, il est à écarter des suspects"
      ]
    },
    {
      page: 37,
      lib: "Sésame",
      texteIndice: [
        "Le sésame pour le musée",
        "Il tient dans la main, permet d'entrer, superposez-le",
        "https://bit.ly/m/2498"
      ]
    },
    {
      page: 99,
      lib_page: "Terminer le parcours",
      lib: "Vous avez terminé le parcours ? Bravo ! Alors où se cache la mosaïque ?",
      lib_win_title: "Bravo ! Félicitations !",
      lib_win_texte: "Votre temps a été enregistré. Retournez voir l'animateur.",
      questions: ["Quelle type de voie ?", "Quel nom de voie ?", "Qui est le coupable du vol ?"],
      answers: [
        ["Impasse", "Square", "Rue", "Allée", "Chemin", "Route", "Musée", "Maison"],
        ["11 novembre", "3 piliers", "Abeilles", "Agrippa", "Aigoual", "Barutel", "Goethe", "Fayard", "Mourrier", "Aucubas", "Carrée"],
        ["Mégane Giree", "Pierre Arancif", "Johan Withmen", "Julien Bondoré"]]
    }
  ];

export default MUSEEROMA;